/**
 * Helpers de formato reutilizables
 */

export const fmtCLP = (n) =>
  (Number(n) || 0).toLocaleString("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  });

export const fmtFecha = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("es-CL", {
      dateStyle: "short",
      timeStyle: "medium",
      timeZone: "America/Santiago",
    });
  } catch {
    return iso || "";
  }
};

export const norm = (s = "") =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const formatPagos = (pagos, fallback = "") => {
  // Mostrar únicamente el medio y el monto aquí.
  // El estado de "pagado" se muestra como columna separada; sólo cuando
  // hay 2 medios de pago se indica qué porción está pendiente en la vista detallada.
  const list = Array.isArray(pagos) ? pagos.filter((p) => p?.medio) : [];
  if (!list.length) return fallback || "";
  return list
    .map((p) => (p.monto != null ? `${p.medio} ${fmtCLP(p.monto)}` : `${p.medio}`))
    .join(" + ");
};

export const saldoPendientePagos = (pagos) => {
  const list = Array.isArray(pagos) ? pagos : [];
  return list.reduce((sum, p) => {
    const pagado = p?.pagado === true || String(p?.pagado).toLowerCase() === "true";
    return sum + (pagado ? 0 : Number(p.monto || 0));
  }, 0);
};
